// import React from 'react'

const Logout = () => {
  //   const handleSignout = () => {
  //     // Add your signout logic here
  //   }

  return (
    <>
      <h1>Logout Success</h1>
    </>
  );
};

export default Logout;
